module.exports = __webpack_public_path__ + "assets/img/hontoyutari-photo01.e772e4ca.jpg";